export default __webpack_public_path__ + "static/media/widget_watchbox_vpmndx1d_buy.20ed10ba.mp3";